(function (upp) {
    'use strict';
    upp
        .config(['$routeProvider',
        function ($routeProvider) {
            var resolver = {
                resolve:$routeProvider.ResolverFactory.moduleIsActivated('cart').resolver
            };
            $routeProvider
                .when('/cart', {
                    redirectTo:'/cart/order'
                })
                .when('/cart/order', {
                    templateUrl: require('../templates/cart-order.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/cart/address', {
                    templateUrl: require('../templates/cart-address.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/cart/payment', {
                    templateUrl: require('../templates/cart-payment.html'),
                    resolve: resolver,
                    showAd: true
                })
                .when('/cart/payment/success', {
                    templateUrl: require('../templates/cart-success.html'),
                    resolve:resolver,
                    showAd:true
                })
                .when('/cart/payment/failure', {
                    templateUrl: require('../templates/cart-failure.html'),
                    resolve:resolver,
                    showAd:true
                })
                .when('/cart/payment/redsys', {
                    templateUrl: require('../templates/cart-redsys-payment.html'),
                    resolve:resolver,
                    showAd:true
                })
            ;
        }])
    ;
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/cart/routes/cart-routes.js